import { axiosFinancial, createAuthHeaders } from "./financialApi";

export const uploadConsigTaxNoteExcel = async (file: File): Promise<any> => {
  const formData = new FormData();
  formData.append("file", file);

  try {
    const response = await axiosFinancial.post(
      "/api/consignado/tax-note/read-excel",
      formData,
      {
        headers: {
          ...createAuthHeaders(),
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Erro ao fazer upload do tax-note:", error);
    throw error;
  }
};

export const exportConsigConsolidatedReport = async (file: File) => {
  const formData = new FormData();
  formData.append("file", file);

  try {
    const response = await axiosFinancial.post(
      "/api/consignado/tax-note/report-excel",
      formData,
      {
        headers: {
          ...createAuthHeaders(),
          "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
      }
    );

    return response.data;
  } catch (error) {
    console.error("Erro ao exportar relatório consolidado:", error);
    throw error;
  }
};
